export default {
    // 前端隐藏的菜单 code：不删除数据库菜单记录，仅不在左侧展示。
    HIDDEN_MENU_CODES: ["system.vip2Benefit"],
    // 前端覆盖菜单展示名称：不修改数据库菜单、SQL 或权限数据。
    MENU_NAME_OVERRIDES: {
        "product.vip2": "超级会员配置",
    },

    // 将菜单列表构造成菜单树
    initMenus(menus){
        if(!menus){
            return [];
        }
        let list =[]; //一级菜单
        let menuIdMap = {}; //id-menu
        let menuPathNameMap ={};
        menus.forEach(o=>{
            let {id, parentId,path} = o;
            menuIdMap[id] = o;
            const isGroup = o.nodeType === "GROUP" || (!o.nodeType && !parentId);
            if(isGroup) {
                list.push(o);
            }
            menuPathNameMap[path]=o;
        });
        window.MENU_PATH_MAP=menuPathNameMap;
        menus.forEach(o=>{
            let {id, parentId} = o;
            if(parentId){ //只处理子菜单
                let parentMenu = menuIdMap[parentId];
                if(parentMenu){//父级菜单不存在，忽略
                    if(!parentMenu.subMenus){
                        parentMenu.subMenus=[o]
                    }else{
                        parentMenu.subMenus.push(o)
                    }
                }
            }

        })
        return this.buildMenus(list);
    },
    buildMenus(list, level = 1){
        if(!list){
            return null;
        }
        return list
            .filter(m => !this.HIDDEN_MENU_CODES.includes(m.code))
            .map(m=>{
                let {id, code, iconKey, name, nodeType, path, subMenus} = m;
                return {
                    id,
                    code,
                    iconKey,
                    name: this.MENU_NAME_OVERRIDES[code] || name,
                    nodeType,
                    path,
                    // 左侧导航固定为一级分组 + 二级页面；保留原始菜单清单供权限和路径映射使用。
                    subMenus: level === 1 ? this.buildMenus(subMenus, level + 1) : null
                }
            })
    }

}
